import type { GeneralFeedPurchase } from "model/feedPurchaseEventTypes";
import {
  GENERAL_FEED_TYPE,
  GENERAL_FEED_UNITS,
  PURCHASE_CURRENCY,
} from "model/feedStockTypes";

export function buildFeedPurchaseLineItem(
  feedType: GENERAL_FEED_TYPE,
  feedUnit: GENERAL_FEED_UNITS,
  feedAmount: string,
  cost: string | undefined
): GeneralFeedPurchase {
  return {
    costCurrency: cost === undefined ? undefined : PURCHASE_CURRENCY.GBP,
    cost: cost ? Number(cost) : undefined,
    unitType: feedUnit,
    feedType,
    amount: Number(feedAmount),
  };
}
